// @generated by protoc-gen-grpc-gateway-es v0.5.0 with parameter "target=ts,generate_name_parser=true"
// @generated from file aiUnitWorkspace/aiUnitWorkspace.proto (package aiUnitWorkspace, syntax proto3)
/* eslint-disable */

import { RPC } from "../runtime";

/**
 * @generated from enum aiUnitWorkspace.Granularity
 */
export enum Granularity {
/**
 * @generated from enum value: WEEKLY = 0;
 */
WEEKLY = "WEEKLY",

/**
 * @generated from enum value: MONTHLY = 1;
 */
MONTHLY = "MONTHLY",
}
/**
 * @generated from message aiUnitWorkspace.AIUnitByWorkspaceRecord
 */
export type AIUnitByWorkspaceRecord = {
/**
 * @generated from field: string hour = 1;
 */
hour?: string;
/**
 * @generated from field: string workspace_id = 2;
 */
workspaceId?: string;
/**
 * @generated from field: string namespace = 3;
 */
namespace?: string;
/**
 * @generated from field: string pod_name = 4;
 */
podName?: string;
/**
 * @generated from field: string username = 5;
 */
username?: string;
/**
 * @generated from field: float ai_units = 6;
 */
aiUnits?: number;
}
;
/**
 * @generated from message aiUnitWorkspace.AIUnitWorkspaceUsageRequest
 */
export type AIUnitWorkspaceUsageRequest = {
/**
 * RFC3339 format with timezone (e.g., "2025-01-01T00:00:00-05:00")
 *
 * @generated from field: string start_date = 1;
 */
startDate?: string;
/**
 * RFC3339 format with timezone (e.g., "2025-01-31T23:59:59-05:00")
 *
 * @generated from field: string end_date = 2;
 */
endDate?: string;
/**
 * @generated from field: repeated string workspaces = 3;
 */
workspaces?: string[];
/**
 * @generated from field: aiUnitWorkspace.UserContext user_context = 4;
 */
userContext?: UserContext;
}
;
/**
 * @generated from message aiUnitWorkspace.AIUnitWorkspaceUsageResponse
 */
export type AIUnitWorkspaceUsageResponse = {
/**
 * @generated from field: repeated aiUnitWorkspace.PodUsageRecord pod_usage_records = 1;
 */
podUsageRecords?: PodUsageRecord[];
/**
 * @generated from field: repeated aiUnitWorkspace.WorkspaceSummary workspace_summaries = 2;
 */
workspaceSummaries?: WorkspaceSummary[];
}
;
/**
 * @generated from message aiUnitWorkspace.WorkspaceSummary
 */
export type WorkspaceSummary = {
/**
 * @generated from field: string workspace_name = 1;
 */
workspaceName?: string;
/**
 * @generated from field: float total_ai_units = 2;
 */
totalAiUnits?: number;
/**
 * @generated from field: repeated aiUnitWorkspace.NamespaceUsage namespaces = 3;
 */
namespaces?: NamespaceUsage[];
}
;
/**
 * @generated from message aiUnitWorkspace.NamespaceUsage
 */
export type NamespaceUsage = {
/**
 * @generated from field: string namespace_name = 1;
 */
namespaceName?: string;
/**
 * @generated from field: float total_ai_units = 2;
 */
totalAiUnits?: number;
}
;
/**
 * @generated from message aiUnitWorkspace.PodUsageRecord
 */
export type PodUsageRecord = {
/**
 * Workspace name
 *
 * @generated from field: string workspace_name = 1;
 */
workspaceName?: string;
/**
 * Namespace name
 *
 * @generated from field: string namespace = 2;
 */
namespace?: string;
/**
 * Pod name
 *
 * @generated from field: string pod_name = 3;
 */
podName?: string;
/**
 * Username
 *
 * @generated from field: string user_name = 4;
 */
userName?: string;
/**
 * AI Unit count
 *
 * @generated from field: float ai_unit = 5;
 */
aiUnit?: number;
}
;
/**
 * @generated from message aiUnitWorkspace.AvailableWorkspacesRequest
 */
export type AvailableWorkspacesRequest = {
/**
 * RFC3339 format with timezone (e.g., "2025-01-01T00:00:00-05:00")
 *
 * @generated from field: string start_date = 1;
 */
startDate?: string;
/**
 * RFC3339 format with timezone (e.g., "2025-01-31T23:59:59-05:00")
 *
 * @generated from field: string end_date = 2;
 */
endDate?: string;
}
;
/**
 * @generated from message aiUnitWorkspace.AvailableWorkspacesResponse
 */
export type AvailableWorkspacesResponse = {
/**
 * @generated from field: repeated string available_workspaces = 1;
 */
availableWorkspaces?: string[];
}
;
/**
 * @generated from message aiUnitWorkspace.AIUnitUsageByPodRequest
 */
export type AIUnitUsageByPodRequest = {
/**
 * RFC3339 format with timezone (e.g., "2025-01-01T00:00:00-05:00")
 *
 * @generated from field: string start_date = 1;
 */
startDate?: string;
/**
 * RFC3339 format with timezone (e.g., "2025-01-31T23:59:59-05:00")
 *
 * @generated from field: string end_date = 2;
 */
endDate?: string;
/**
 * IANA timezone name (e.g. "Asia/Colombo"). The daily buckets in the response follow it, so
 * DST transitions inside the range are handled correctly and the days stay right even when no
 * dates are sent. Falls back to the fixed offset carried by start_date when empty.
 *
 * @generated from field: string timezone = 8;
 */
timezone?: string;
/**
 * @generated from field: string username = 3;
 */
username?: string;
/**
 * @generated from field: string pod_name = 4;
 */
podName?: string;
/**
 * @generated from field: string namespace = 5;
 */
namespace?: string;
/**
 * @generated from field: string workspace = 6;
 */
workspace?: string;
/**
 * @generated from field: aiUnitWorkspace.Granularity granularity = 7;
 */
granularity?: Granularity;
}
;
/**
 * @generated from message aiUnitWorkspace.AIUnitUsageByPodResponse
 */
export type AIUnitUsageByPodResponse = {
/**
 * @generated from field: map<string, float> data = 1;
 */
data?: { [key: string]: number };
}
;
/**
 * @generated from message aiUnitWorkspace.UserContext
 */
export type UserContext = {
/**
 * @generated from field: string user_email = 1;
 */
userEmail?: string;
/**
 * @generated from field: string source_ip_address = 2;
 */
sourceIpAddress?: string;
/**
 * @generated from field: string user_agent = 3;
 */
userAgent?: string;
}
;
/**
 * @generated from rpc aiUnitWorkspace.AiUnitWorkspaceService.GetAIUnitWorkspaceUsage
 */
export const AiUnitWorkspaceService_GetAIUnitWorkspaceUsage = new RPC<AIUnitWorkspaceUsageRequest,AIUnitWorkspaceUsageResponse>("POST", "/getAIUnitWorkspaceUsage");
/**
 * @generated from rpc aiUnitWorkspace.AiUnitWorkspaceService.GetAvailableWorkspaces
 */
export const AiUnitWorkspaceService_GetAvailableWorkspaces = new RPC<AvailableWorkspacesRequest,AvailableWorkspacesResponse>("GET", "/getAvailableWorkspaces");
/**
 * @generated from rpc aiUnitWorkspace.AiUnitWorkspaceService.GetAIUnitUsageByPod
 */
export const AiUnitWorkspaceService_GetAIUnitUsageByPod = new RPC<AIUnitUsageByPodRequest,AIUnitUsageByPodResponse>("GET", "/getAiUnitUsageByPod");
